import { projectLimitsAPI } from "./api";

export const getSbsProjects = async () => {
  const res = await projectLimitsAPI.getSbsProjects();
  return res?.data ?? [];
};

export const getProjectTypes = async () => {
  const res = await projectLimitsAPI.getProjectTypes();
  return res?.data ?? [];
};

export const getSbsProjectMaterialLimits = async (
  project_type_id,
  sbs_project_id
) => {
  if (!project_type_id || !sbs_project_id) return [];
  const res = await projectLimitsAPI.getSbsProjectMaterialLimits(
    project_type_id,
    sbs_project_id
  );
  return res?.data ?? [];
};

export { searchMaterialsForLimit } from "@/views/handbook/MaterialLimits/services";

export const addSbsProjectMaterialLimit = async (
  project_type_id,
  sbs_project_id,
  body
) => {
  const res = await projectLimitsAPI.addSbsProjectMaterialLimit(
    project_type_id,
    sbs_project_id,
    body
  );
  return res?.data ?? res;
};

export const updateSbsProjectMaterialLimit = async (
  project_type_id,
  sbs_project_id,
  body
) => {
  const res = await projectLimitsAPI.updateSbsProjectMaterialLimit(
    project_type_id,
    sbs_project_id,
    body
  );
  return res?.data ?? res;
};

export const deleteSbsProjectMaterialLimit = async (
  project_type_id,
  sbs_project_id,
  limit_id
) => {
  const res = await projectLimitsAPI.deleteSbsProjectMaterialLimit(
    project_type_id,
    sbs_project_id,
    limit_id
  );
  return res?.data ?? res;
};

export const fillSbsProjectMaterialLimits = async (
  project_type_id,
  sbs_project_id
) => {
  const res = await projectLimitsAPI.fillSbsProjectMaterialLimits(
    project_type_id,
    sbs_project_id
  );
  return res?.data ?? res;
};

export const projectLimitsColumns = [
  {
    name: "material_name",
    field: "material_name",
    label: "Материал",
    align: "left",
  },
  {
    name: "unit_name",
    field: "unit_name",
    label: "Ед. изм.",
    align: "center",
  },
  {
    name: "limit_amount",
    field: "limit_amount",
    label: "Лимит",
    align: "right",
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];
